import React from "react";
import PropTypes from "prop-types";
import Base from "../Base";
import TimePicker from "components/common/TimePicker";

@autobind
/**
 *
 */
export default class Time extends Base {
  static propTypes = {
    ...Base.propTypes,
    value: PropTypes.string,
  };

  /**
   *
   * @return {XML}
   */
  get _component() {
    return <TimePicker onChange={(value) => this.props.onChange(app.transform.fa2en(value))} />;
  }
}
